import React from 'react'
import { Box } from '@mui/material'
import ModifyStyle from './PlanStyle'

/**
 * Left-side panel for planning pages (Copy / Target / Chart + optional chart).
 *
 * This is extracted from the legacy LivePlanEdit component so the Weekly UI can
 * reuse the panel without also rendering the legacy monthly planning table.
 */
function PlanLeftPanel({ children }) {
  return (
    <Box sx={ModifyStyle.leftSection}>
      <Box sx={ModifyStyle.leftContent}>{children}</Box>
    </Box>
  )
}

export default PlanLeftPanel

